import { MalpracticeInsurance } from '~/types';
import { CreateMalpracticeInsuranceFormValues, MalpracticeInsuranceFormValues } from './types';

export const malInsuranceFormToApi = (formInsurance: CreateMalpracticeInsuranceFormValues) => {
  return JSON.stringify({
    ...formInsurance,
    policyType: formInsurance.policyType.value,
  } as Omit<MalpracticeInsurance, 'id'>);
};

export const malInsuranceApiToForm = (
  malpracticeInsuranceStr: string
): MalpracticeInsuranceFormValues => {
  const malpracticeInsurance: MalpracticeInsurance = JSON.parse(malpracticeInsuranceStr);

  // AI-parsed records may return null for fields the form requires.
  // Explicit guards override spread values for at-risk fields.
  return {
    ...malpracticeInsurance,
    activeFlag: malpracticeInsurance.activeFlag ?? false,
    coverageLimits: malpracticeInsurance.coverageLimits ?? '',
    effectiveDate: malpracticeInsurance.effectiveDate ?? '',
    expiryDate: malpracticeInsurance.expiryDate ?? '',
    insuranceCompany: malpracticeInsurance.insuranceCompany ?? '',
    policyNumber: malpracticeInsurance.policyNumber ?? '',
    producer: malpracticeInsurance.producer ?? '',
    policyType: malpracticeInsurance.policyType
      ? { label: malpracticeInsurance.policyType, value: malpracticeInsurance.policyType }
      : { label: '', value: '' },
    validFlag: true,
    warnings: {},
  };
};

export const malInsurancesApiToForm = (
  malpracticeInsurancesStr: string
): MalpracticeInsuranceFormValues[] => {
  const malpracticeInsurances: MalpracticeInsurance[] = JSON.parse(malpracticeInsurancesStr);
  return malpracticeInsurances.map((malpracticeInsurance) =>
    malInsuranceApiToForm(JSON.stringify(malpracticeInsurance))
  );
};
